import { render, staticRenderFns } from "./sensitivity.vue?vue&type=template&id=c2aa7040&scoped=true"
import script from "./sensitivity.vue?vue&type=script&lang=js"
export * from "./sensitivity.vue?vue&type=script&lang=js"
import style0 from "./sensitivity.vue?vue&type=style&index=0&id=c2aa7040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aa7040",
  null
  
)

export default component.exports